import { ErrorButton } from '@design/components/error-message/ErrorMessage';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseErrorView } from '../base-error-view/BaseErrorView';
import styles from './ErrorMessageWrapper.module.scss';

type Variant = 'error' | 'empty';

export interface ErrorMessageWrapperProps {
  className?: string;
  variant?: Variant;
  displayIcon?: boolean;
  customIcon?: ReactNode;
  title?: string;
  subTitle?: string;
  showBorder?: boolean;
  buttonProps?: ErrorButton;
}

export const ErrorMessageWrapper = ({
  className,
  displayIcon,
  customIcon,
  variant = 'error',
  title,
  subTitle,
  showBorder = true,
  buttonProps,
  ...rest
}: ErrorMessageWrapperProps) => {
  const { t } = useTranslation(['widget', 'common']);

  const messageComponent = {
    error: (
      <BaseErrorView
        title={title}
        subtitle={subTitle}
        displayIcon={displayIcon ? 'error' : undefined}
        customIcon={customIcon}
        buttonProps={buttonProps}
      />
    ),
    empty: (
      <BaseErrorView
        displayIcon={displayIcon ? 'empty' : undefined}
        customIcon={customIcon}
        title={title ?? t('widget:empty.titleEmpty')}
        subtitle={subTitle ?? t('widget:empty.subtitleEmpty')}
        buttonProps={buttonProps}
      />
    ),
  };

  return (
    <div
      {...rest}
      className={clsx(styles.styledErrorMessageRoot, className, {
        [styles.showBorder]: showBorder,
      })}
    >
      {messageComponent[variant]}
    </div>
  );
};
